export default __webpack_public_path__ + "static/media/nft_right_popup.e780257e.svg";